import React, { useState } from "react";
import "./DivisionTeamsTable.css";

function DivisionTeamsTable({
  teams,
  isTeamInBracket,
  teamHasScore,
  removeTeamFromBracket,
  removeTeamFromTournament,
}) {
  const [selectedTeams, setSelectedTeams] = useState([]);

  if (!teams) return null;

  const getTeamKey = (team) => team.slt_id ?? team.id;

  const removableTeams = teams.filter((team) => {
    const teamKey = getTeamKey(team);
    return !(isTeamInBracket(teamKey) && teamHasScore(teamKey));
  });

  const selectedRemovableTeams = teams.filter((team) =>
    selectedTeams.includes(getTeamKey(team))
  );

  const allRemovableSelected =
    removableTeams.length > 0 &&
    selectedTeams.length === removableTeams.length;

  const handleSelectAll = () => {
    if (allRemovableSelected) {
      setSelectedTeams([]);
    } else {
      setSelectedTeams(removableTeams.map((team) => getTeamKey(team)));
    }
  };

  const handleSelectTeam = (team) => {
    const teamKey = getTeamKey(team);

    setSelectedTeams((prev) =>
      prev.includes(teamKey)
        ? prev.filter((id) => id !== teamKey)
        : [...prev, teamKey]
    );
  };

  const handleRemoveSelected = async () => {
    if (selectedRemovableTeams.length === 0) {
      return alert("Please select at least one team to remove.");
    }

    if (!window.confirm("Remove selected teams from this tournament?")) return;

    for (const team of selectedRemovableTeams) {
      await removeTeamFromTournament(team);
    }

    setSelectedTeams([]);
  };



  return (
    <div className="divisionTeamsTablePage">
      <div className="divisionTeamsTablePage-header">
        <h3>Tournament Teams</h3>

        <button
          type="button"
          className="divisionTeamsTablePage-deleteSelectedBtn"
          onClick={handleRemoveSelected}
          disabled={selectedTeams.length === 0}
        >
          Remove Selected
          {selectedTeams.length > 0 && ` (${selectedTeams.length})`}
        </button>
      </div>

      <div className="divisionTeamsTablePage-tableWrap">
        <table className="divisionTeamsTablePage-table">
          <thead>
            <tr>
              <th className="divisionTeamsTablePage-checkboxHeader">
                <input
                  type="checkbox"
                  checked={allRemovableSelected}
                  onChange={handleSelectAll}
                  disabled={removableTeams.length === 0}
                />
              </th>

              <th className="divisionTeamsTablePage-posHeader">Pos</th>
              <th>Team</th>
              <th className="divisionTeamsTablePage-recordHeader">W-L</th>
            </tr>
          </thead>

          <tbody>
            {teams.length === 0 ? (
              <tr>
                <td colSpan="4" className="divisionTeamsTablePage-emptyCell">
                  No teams added yet.
                </td>
              </tr>
            ) : (
              teams.map((team, i) => {
                const teamKey = getTeamKey(team);
                const isLocked = isTeamInBracket(teamKey) && teamHasScore(teamKey);

                return (
                  <tr
                    key={teamKey}
                    className={
                      isLocked
                        ? "divisionTeamsTablePage-row divisionTeamsTablePage-rowLocked"
                        : "divisionTeamsTablePage-row"
                    }
                  >
                    <td className="divisionTeamsTablePage-checkboxCell">
                      <input
                        type="checkbox"
                        checked={selectedTeams.includes(teamKey)}
                        onChange={() => handleSelectTeam(team)}
                        disabled={isLocked}
                      />
                    </td>

                    <td className="divisionTeamsTablePage-posCell">
                      {i + 1}
                    </td>

                    <td className="divisionTeamsTablePage-teamCell">
                      <div className="divisionTeamsTablePage-teamNameWrap">
                        <span
                          className="divisionTeamsTablePage-teamName"
                          draggable={!isLocked}
                          onDragStart={(e) => {
                            e.stopPropagation();
                            e.dataTransfer.setData("team_id", String(teamKey));
                            e.dataTransfer.setData("team_name", team.name || "");
                            e.dataTransfer.setData("team_position", String(i));
                          }}
                        >
                          {team.name}
                        </span>

                        {isTeamInBracket(teamKey) && !teamHasScore(teamKey) && (
                          <button
                            type="button"
                            className="divisionTeamsTablePage-bracketRemoveBtn"
                            onClick={(e) => {
                              e.stopPropagation();
                              removeTeamFromBracket(teamKey);
                            }}
                            title="Remove from bracket only"
                          >
                            ×
                          </button>
                        )}

                        {isLocked && (
                          <span className="divisionTeamsTablePage-lockedText">
                            Locked
                          </span>
                        )}
                      </div>
                    </td>

                    <td className="divisionTeamsTablePage-recordCell">
                      {team.wins ?? 0}-{team.losses ?? 0}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DivisionTeamsTable;